export default __webpack_public_path__ + "static/media/Michelle_Glogovac_AHV_In_Moms_We_Trust.5a811d21.jpg";